<template>
  <div class="page-container">
    <div class="page-header">
      <div class="page-title">
        센서 목록
        <span class="count-text">
          {{ loggerName ? loggerName + ' / ' : '' }}총 {{ resolvedTotalCount }} 건
        </span>
      </div>

      <div class="header-buttons">
        <!-- 수정 -->
        <button class="btn ghost" @click="onClickBack">목록으로</button>
        <button class="btn primary d-none" @click="onClickCreate">신규 등록</button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="placeholder-text">
        <div class="table-section">

          <table v-if="tableRows.length" class="data-table sensor-table">
            <colgroup>
              <col class="col-id" />
              <col class="col-sensor-name" />
              <col class="col-sensor-code" />
              <col class="col-collect-type" />
              <col class="col-raw-key" />
              <col class="col-channel-no" />
              <col class="col-unit" />
              <col class="col-use-yn" />
              <col class="col-status" />
              <col class="col-actions" />
            </colgroup>

            <thead>
              <tr>
                <th>ID</th>
                <th>센서명</th>
                <th>센서코드</th>
                <th>수집방식</th>
                <th>원본키</th>
                <th>채널번호</th>
                <th>단위</th>
                <th>사용여부</th>
                <th>상태</th>
                <th class="col-actions">작업</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="row in tableRows" :key="row.id">
                <td>{{ row.id }}</td>

                <td class="td-ellipsis" :title="row.name || '-'">
                  {{ row.name || '-' }}
                </td>

                <td>{{ row.code || '-' }}</td>
                <td>{{ row.collectType || '-' }}</td>

                <td class="td-ellipsis" :title="row.rawMeasureKey || '-'">
                  {{ row.rawMeasureKey || '-' }}
                </td>

                <td>{{ row.channelNo || '-' }}</td>
                <td>{{ row.unit || '-' }}</td>

                <td>
                  <div class="use-toggle-wrap">
                    <button
                      type="button"
                      class="toggle-switch toggle-switch-sm"
                      :class="{ active: row.useYn, disabled: loadingUseYnId === row.id }"
                      :disabled="loadingUseYnId === row.id"
                      @click="toggleSensorUseYn(row)"
                    >
                      <span class="toggle-thumb"></span>
                    </button>

                    <span class="toggle-text">
                      {{ row.useYn ? '사용' : '미사용' }}
                    </span>
                  </div>
                </td>

                <td>
                  <span
                    class="status-pill"
                    :class="row.status === '정상' ? 'is-normal' : 'is-warning'"
                  >
                    {{ row.status || '-' }}
                  </span>
                </td>

                <td class="td-actions">
                  <div class="row-actions">

                    <!-- 수정 -->
                    <button class="btn xs primary" @click="onClickDetail(row)">
                      상세보기
                    </button>

                    <button
                      class="btn xs secondary"
                      @click="onClickSensorMeasurements(row)"
                    >
                      측정목록
                    </button>

                    <button
                      class="btn xs danger outline d-none"
                      @click="onClickDelete(row)"
                    >
                      삭제
                    </button>

                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div v-else class="table-empty">
            표시할 센서 데이터가 없습니다
          </div>

        </div>

        <PaginationBar
          :currentPage="currentPage"
          :totalPages="totalPages"
          :groupSize="groupSize"
          @change-page="goToPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios'
import PaginationBar from '@/components/admin/PaginationBar.vue'

export default {
  name: 'SensorList',

  components: {
    PaginationBar,
  },

  props: {
    sensorLoggerId: {
      type: Number,
      required: true,
    },
    loggerName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tableRows: [],
      totalCount: 0,
      totalPages: 0,
      currentPage: 0,
      size: 15,
      groupSize: 5,
      loading: false,
      loadingUseYnId: null,
    }
  },

  computed: {
    resolvedTotalCount() {
      return this.totalCount || this.tableRows.length
    },
  },

  mounted() {
    this.fetchSensorList()
  },

  watch: {
    sensorLoggerId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.currentPage = 0
        this.fetchSensorList()
      }
    },
  },

  methods: {
    async fetchSensorList() {
      if (!this.sensorLoggerId) {
        this.tableRows = []
        this.totalCount = 0
        this.totalPages = 0
        this.currentPage = 0
        return
      }

      this.loading = true

      try {
        const response = await api.get('/app/sensor/list', {
          params: {
            sensorLoggerId: this.sensorLoggerId,
            page: this.currentPage,
            size: this.size,
            orderBy: 'createdAtDesc',

            // 로거/센서 관리 > 센서 목록 화면 전용
            // ANALOG: amountCh0 ~ amountCh7 만 표시
            // RS485 : Dev 기반 센서만 표시
            displayManageTarget: true,
          },
        })

        const result = response.data
        const pageData = result?.result

        this.tableRows = Array.isArray(pageData?.content)
          ? pageData.content
          : []

        this.totalCount = Number(pageData?.totalElements ?? this.tableRows.length)
        this.totalPages = Number(pageData?.totalPages ?? 0)
        this.currentPage = Number(pageData?.number ?? this.currentPage)

        console.log('sensor response.data =', result)
        console.log('sensor tableRows =', this.tableRows)
      } catch (error) {
        console.error('센서 목록 조회 실패', error)
        this.tableRows = []
        this.totalCount = 0
        this.totalPages = 0
      } finally {
        this.loading = false
      }
    },

    async toggleSensorUseYn(row) {
      if (!row || !row.id) return

      const originalUseYn = !!row.useYn
      const nextUseYn = !originalUseYn

      row.useYn = nextUseYn
      this.loadingUseYnId = row.id

      try {
        await api.post('/app/sensor/useYn', {
          id: row.id,
          useYn: nextUseYn,
        })
      } catch (error) {
        console.error('센서 사용여부 수정 실패', error)
        row.useYn = originalUseYn
        alert('사용여부 변경에 실패했습니다.')
      } finally {
        this.loadingUseYnId = null
      }
    },

    goToPage(pageNo) {
      if (pageNo < 0 || pageNo >= this.totalPages || pageNo === this.currentPage) {
        return
      }

      this.currentPage = pageNo
      this.fetchSensorList()
    },

    onClickBack() {
      this.$emit('back')
    },

    onClickCreate() {
      this.$emit('create', { sensorLoggerId: this.sensorLoggerId })
    },

    onClickDetail(row) {
      this.$emit('detail', row)
    },

    onClickSensorMeasurements(row) {
      this.$emit('measurements', row)
    },

    onClickDelete(row) {
      this.$emit('delete', row)
    },
  },
}
</script>

<style scoped>
@import "@/styles/admin/admin-layout.css";
@import "@/styles/admin/admin-table.css";
@import "@/styles/admin/admin-button.css";
@import "@/styles/admin/admin-input.css";
@import "@/styles/admin/admin-pagination.css";
@import "@/styles/admin/admin-toggle.css";

/* 페이지 전용: 컬럼 폭만 유지 */
.sensor-table {
  min-width: 1180px;
}

.col-id {
  width: 70px;
}

.col-sensor-name {
  width: 180px;
}

.col-sensor-code {
  width: 140px;
}

.col-collect-type {
  width: 120px;
}

.col-raw-key {
  width: 180px;
}

.col-channel-no {
  width: 100px;
}

.col-unit {
  width: 80px;
}

.col-use-yn {
  width: 120px;
}

.col-status {
  width: 100px;
}

.col-actions {
  width: 190px;
}

/* =========================
   TABLE ROW ACTIVE
========================= */

.data-table tbody tr {
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.data-table tbody tr:hover td {
  background: #f8fafc;
}

.data-table tbody tr:hover {
  box-shadow: inset 3px 0 0 #e58a13;
}
</style>